import Div from "@jumbo/shared/Div/Div";
import React, { useEffect, useState } from "react";
import Heading from "app/pages/Component/Heading";
import Loader from "../Component/Loader";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Axios } from "index";
import AllApis from "app/Apis/apis";

export default function ListFaqs() {
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(0);
  const [faqItems, setFaqItems] = useState([]); // Use null for all closed initially
  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpanded(isExpanded ? index : null);
  };

  useEffect(() => {
    (async function () {
      let response;
      try {
        response = await Axios.get(AllApis.faq.list);

        if (response?.data?.statusCode) {
          setFaqItems(response?.data?.data?.faqs);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  
  return (
    <Div sx={{ mt: -4 }}>
      <Heading Name={"FAQs"} />
      {loading && <Loader />}
      <Div sx={{ mt: 5 }}>
        {faqItems.map((item, index) => (
          <Accordion
            key={index}
            expanded={expanded === index}
            onChange={handleAccordionChange(index)}
            square
            sx={{ borderRadius: 2, mb: 1 }}
          >
            <AccordionSummary
              expandIcon={expanded == index ? <RemoveIcon /> : <AddIcon />}
              aria-controls={`panel${index + 1}-content`}
              id={`panel${index + 1}-header`}
              sx={{
                flexDirection: "row-reverse",
                bgcolor: "#7352C7",
                "& .MuiAccordionSummary-content": {
                  alignItems: "center",
                },
                ".MuiAccordionSummary-expandIconWrapper": {
                  borderRadius: 1,
                  border: 1,
                  color: "white",
                  borderColor: "transparent",
                  transform: "none",
                  height: 28,
                  width: 28,
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,

                  "&.Mui-expanded": {
                    transform: "none",
                    color: "white",
                    borderColor: "transparent",
                  },

                  "& svg": {
                    fontSize: "1.25rem",
                  },
                },
              }}
            >
              <Typography variant="h4" sx={{ color: "white", mt: 1 }}>
                {item.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{ backgroundColor: "white", minHeight: "150px" }}
            >
              <Typography variant="h5">{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Div>
    </Div>
  );
}

{
  /* <Accordion
  expanded={expanded}
  onChange={handleChange}
  square
  sx={{ borderRadius: 2 }}
>
  <AccordionSummary
    expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
    aria-controls="panel1bh-content"
    id="panel1bh-header"
    sx={{
      flexDirection: "row-reverse",

      "& .MuiAccordionSummary-content": {
        alignItems: "center",
      },
      ".MuiAccordionSummary-expandIconWrapper": {
        borderRadius: 1,
        border: 1,
        color: "text.secondary",
        borderColor: "divider",
        transform: "none",
        height: 28,
        width: 28,
        alignItems: "center",
        justifyContent: "center",
        mr: 2,

        "&.Mui-expanded": {
          transform: "none",
          color: "error.main",
          borderColor: "error.main",
        },

        "& svg": {
          fontSize: "1.25rem",
        },
      },
    }}
  >
    <Div sx={{ flexShrink: 0, px: 1 }}>
      <Avatar
        sx={{ width: 52, height: 52 }}
        alt={item.name}
        src={item.logo}
        variant="rounded"
      />
    </Div>

    <Div sx={{ width: "25%", flexShrink: 0, px: 1 }}>
      <Typography variant={"h5"} mb={0.5}>
        {item.name}
      </Typography>
      <Typography fontSize={"12px"} variant={"body1"} color={"text.secondary"}>
        <CalendarTodayOutlinedIcon
          sx={{ verticalAlign: "middle", fontSize: "1rem", mt: -0.25 }}
        />{" "}
        {item.date}
      </Typography>
    </Div>
    <Div sx={{ width: "18%", flexShrink: 0, px: 1 }}>
      <LinearProgress
        variant={"determinate"}
        color={"primary"}
        value={item.progress}
        sx={{
          height: 8,
          borderRadius: 2,
          backgroundColor: "#E9EEEF",
        }}
      />
    </Div>
    <Div sx={{ width: "16%", flexShrink: 0, px: 1 }}>
      <Typography
        fontSize={"12px"}
        variant={"h6"}
        color={"text.secondary"}
        mb={0.25}
      >
        Deadline
      </Typography>
      <Typography variant={"body1"}>{item.deadline}</Typography>
    </Div>
    <Div sx={{ width: "15%", flexShrink: 0, px: 1 }}>
      <Typography
        fontSize={"12px"}
        variant={"h6"}
        color={"text.secondary"}
        mb={0.25}
      >
        Status
      </Typography>
      <Chip color="primary" size={"small"} label={item.status.label} />
    </Div>
    <AvatarGroup max={3}>
      {item.team.map((teamMember, index) => (
        <Avatar key={index} alt={teamMember.name} src={teamMember.profilePic} />
      ))}
    </AvatarGroup>
  </AccordionSummary>
  <AccordionDetails
    sx={{
      borderTop: 1,
      borderColor: "divider",
      p: (theme) => theme.spacing(2, 2, 2, 7.5),
    }}
  >
    <Typography variant={"h4"}>Description</Typography>
    <Typography variant={"body1"} color={"text.secondary"}>
      {item.description}
    </Typography>
  </AccordionDetails>
</Accordion>; */
}
